module.exports = __webpack_public_path__ + "assets/check.a09fd48c.svg";